module.exports = "<p>\n  clients works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/masters/clients/clients.component.html
// module id = ./src/app/masters/clients/clients.component.html
// module chunks = main